module.exports = __webpack_public_path__ + "img/transfers-illustration.5c12b3ef.png";